import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useState, useCallback, useRef } from 'react';
import { CookiesProvider } from 'react-cookie';

// project import
import MainHeader from '../../pages/com/MainHeader';
import MainFooter from '../../pages/com/MainFooter';
import MainPage from '../../pages/main/MainPage';
import QuickService from '../../pages/main/QuickService';
import PageNavigation from '../../pages/com/PageNavigation';

import req from '../../utils/restApi';
import MainNoticePopup from '../../pages/popup/MainNoticePopup';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const location = useLocation();
    const isRootPath = location.pathname === '/';

    const [notices, setNotices] = useState(null);
    const [popupNotice, setPopupNotice] = useState(null);

    const refNoticeBody = useRef();

    useEffect(() => {
        if (notices == null) {
            reqNotice();
        }
    }, [notices]);
    useEffect(() => {
        hasScrolled2();
    }, []);

    const reqNotice = useCallback(() => {
        req('/api/notice/all', {}, (response) => {
            if (response.data?.length > 0) {
                setList(response.data);
                initMainVisual();
            } else {
                if (refNoticeBody.current) {
                    refNoticeBody.current.style.display = 'none';
                }
            }
        });
    }, []);

    const setList = (list) => {
        if (list) {
            let popupNotice = null;
            for (let n of list) {
                if (popupNotice === null && n.popup) {
                    popupNotice = n;
                }
            }
            setPopupNotice(popupNotice);
        }
    };

    return (
        <>
            <div id="wrap">
                <CookiesProvider>
                    <MainHeader />
                    {isRootPath ? (
                        <>
                            <MainPage />
                            <MainNoticePopup notice={popupNotice} />
                        </>
                    ) : (
                        <>
                            <main id="container">
                                <PageNavigation />
                                <Outlet />
                            </main>
                        </>
                    )}
                    <QuickService />
                    <MainFooter />
                </CookiesProvider>
            </div>
        </>
    );
};

export default MainLayout;
